import { from } from "rxjs";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseSkipProcessSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { IdQuickSkip } from "../../../quick-skip-dialog/IdQuickSkip";
export var pathSkipBuildingProduction = function (action, state$) {
    return from([
        actionOngoingPurchaseSkipProcessSelect(IdQuickSkip.Production),
        actionModalOpen(IdModal.SkipProcess),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathSkipBuildingProduction.ts
// module id = 2082
// module chunks = 3